module.exports = __webpack_public_path__ + "img/support.0d3fc751.webp";